export const RECORDS_LISTING_COLUMNS = [
  'Client Name',
  'Note Type',
  'Visit Type',
  'Range',
  'Created At',
]

export const RECORDS_SORTING_COLUMNS = {
  'Client Name': 'clientName',
  'Note Type': 'noteType',
  'Visit Type': 'visitType',
  'Range' : `dateRange`,
  'Created At': 'date',
}

export const RECORDS_COLUMNS_DATA_MAPPING = {
  'Client Name': 'clientName',
  'Note Type': 'noteType',
  'Visit Type': 'visitType',
  'Range' : `dateRange`,
  'Created At': 'date',
}

export const ASSESSMENT_COLUMNS = [
  'Client Name',
  'Note Type',
]
export const ASSESSMENT_SORTING_COLUMNS = {
  'Client Name': 'clientName',
  'Note Type': 'noteType',
}
export const ASSESSMENT_COLUMNS_DATA_MAPPING = {
  'Client Name': 'clientName',
  'Note Type': 'noteType',
}
